import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledSpan = styled.span`
  cursor: pointer;
`;

const GroupCellRenderer = ({ data, node }) => {
  const [open, setOpen] = useState(node.expanded);
  const [prevExpanded, setPrevExpanded] = useState(false);
  const defaultExpanded = useSelector(state => state.worklist.defaultExpanded);

  useEffect(() => {
    if (prevExpanded !== defaultExpanded) {
      setOpen(defaultExpanded);
      node.setExpanded(defaultExpanded);
      setPrevExpanded(defaultExpanded);
    }
  }, [defaultExpanded]);

  useEffect(() => {
    if (!data?.children?.length) {
      node.setExpanded(false);
      setOpen(false);
    }
  }, [data?.children?.length]);

  const handleClick = () => {
    node.setExpanded(!open);
    setOpen(c => !c);
  };
  if (!data?.children?.length) {
    return null;
  }
  return (
    <StyledSpan
      className={`ag-icon ag-icon-tree-${open ? 'open' : 'closed'}`}
      onClick={handleClick}
    />
  );
};

GroupCellRenderer.propTypes = {
  node: PropTypes.object,
  data: PropTypes.object,
};

export default GroupCellRenderer;
